import http from "@/shared/services/http";

export const changePassword = (data: any) => http.put(`v1/accounts/update-password`, data);
export const updateInformation = (data: any) => http.put(`v1/customer/customers/update-profile`, data);
export const verificationGroups = (data: any) => http.post(`auth/verification-email`, data);
export const createGroups = (data: any) => http.post(`v1/customer/customers`, data);
export const getGroups = (params: any) => http.get(`v1/customer/customers`, { params });
export const getMember = (data: any) => http.get(`v1/customer/customers/${data}`);
export const getApiKeys = (params: any) => http.get(`v1/customer/api-keys`, { params });
export const createApiKeys = () => http.post(`v1/customer/api-keys`);
export const deleteApiKeys = (id: any) => http.delete(`v1/customer/api-keys/${id}`);
